import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const OrderManagementHeader: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 4 }}>
      <Typography
        variant="h3"
        component="h1"
        gutterBottom
        sx={{
          fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" },
          fontWeight: 800,
          background: "linear-gradient(135deg, #ff0080 0%, #00d4ff 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {t('admin.orderManagement')}
      </Typography>
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ fontSize: { xs: "0.875rem", sm: "1rem" } }}
      >
        {t('admin.trackAndManageOrders')}
      </Typography>
    </Box>
  );
};

export default OrderManagementHeader;